import standardAPI from '@/api/standard_items';

const state = {
  attractions: [],
  attractions_status: '',
  attractions_MetaData: {},
  attractions_page: 1,
  attractions_perPage: 10,
};

const responseUrl = '/attractions';

const getters = {};

const actions = {
  set_current_page ({ commit }, page) {
    commit('SET_CURRENT_PAGE', page);
  },
  set_perPage ({ commit }, max) {
    commit('SET_PER_PAGE', max);
  },
  fetch_attractions ({ commit }, getOptions) {
    commit('ATTRACTIONS_REQUEST');
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            commit('ATTRACTIONS_SUCCESS', response);
            commit('ATTRACTIONS_READY');
            resolve(response);
          } else if (response.status === 404) {
            commit('ATTRACTIONS_READY');
            reject(response);
          } else {
            commit('ATTRACTIONS_ERROR');
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  fetch_attractions_silent ({ commit }, getOptions) {
    const preparedOptions = {
      getParams: getOptions.pageOptions,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.get_items((response) => {
        try {
          if (response && response.status !== 404) {
            resolve(response);
          } else if (response.status === 404) {
            reject(response);
          } else {
            reject(response);
          }
        } catch (error) {
          console.log(error);
        }
      }, preparedOptions);
    });
  },
  add_attraction ({ commit, dispatch }, itemData) {
    commit('ATTRACTIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.add_item(preparedData, (response) => {
        if (response.status === 'created') {
          resolve(response);
        } else {
          commit('ATTRACTIONS_READY');
          reject(response);
        }
      });
    });
  },
  edit_attraction ({ commit, dispatch }, itemData) {
    commit('ATTRACTIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl + '/',
    };
    return new Promise((resolve, reject) => {
      standardAPI.edit_item(preparedData, (response) => {
        if (response.status === 'updated') {
          resolve(response);
        } else {
          commit('ATTRACTIONS_READY');
          reject(response);
        }
      });
    });
  },
  remove_attraction ({ commit, dispatch }, itemData) {
    commit('ATTRACTIONS_REQUEST');
    const preparedData = {
      itemData,
      url: responseUrl,
    };
    return new Promise((resolve, reject) => {
      standardAPI.remove_items(preparedData, (response) => {
        if (response.status === 'deleted') {
          resolve(response);
        } else {
          commit('ATTRACTIONS_READY');
          reject(response);
        }
      });
    });
  },
  reorder_attraction ({ commit, dispatch }, orderData) {
    const preparedData = {
      orderData,
      url: responseUrl + '/reorder',
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
  set_attraction_order ({ commit, dispatch }, itemData) {
    const preparedData = {
      itemData,
      url: responseUrl + '/set-reorder-index/' + itemData.id,
    };
    return new Promise((resolve, reject) => {
      standardAPI.reorder_item_number(preparedData, (response) => {
        if (response.status === 'reorder') {
          resolve(response);
        } else {
          reject(response);
        }
      });
    });
  },
};

const mutations = {
  SET_CURRENT_PAGE: (state, pageNumber) => {
    state.attractions_page = pageNumber;
  },
  SET_PER_PAGE: (state, max) => {
    state.attractions_perPage = max;
  },
  ATTRACTIONS_READY: (state) => {
    state.attractions_status = 'ready';
  },
  ATTRACTIONS_REQUEST: (state) => {
    state.attractions_status = 'loading';
  },
  ATTRACTIONS_SUCCESS: (state, response) => {
    if (response && response.meta) {
      state.attractions_MetaData.meta = response.meta;
      state.attractions_MetaData.links = response.links;
    }
    state.attractions = response.data ? response.data.map((attraction) => {
      attraction.checked = false; // need for some pages where we can select attractions
      return attraction;
    }) : [];
    state.attractions_status = 'success';
  },
  ATTRACTIONS_ERROR: (state) => {
    state.attractions_status = 'error';
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
